import { MutationCache, QueryClient } from '@tanstack/react-query';
import { ApiError } from '@/lib/api/client';
import { toast } from '@/stores/toast.store';

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      refetchOnWindowFocus: true,
      retry: (count, err) => !(err instanceof ApiError && err.status < 500) && count < 2,
    },
  },
  // Every failed mutation shows its (Arabic) server message unless the screen handles it.
  mutationCache: new MutationCache({
    onError: (err, _vars, _ctx, mutation) => {
      if (mutation.meta?.silent) return;
      toast.error(err instanceof ApiError ? err.message : 'تعذر تنفيذ العملية');
    },
  }),
});

declare module '@tanstack/react-query' {
  interface Register {
    mutationMeta: { silent?: boolean };
  }
}
